import * as React from 'react';

function EpassportContinue() {
    React.useEffect(() => {
        if (parent.location.href.indexOf('/main/account') !== -1) {
            if (window.location.href.indexOf('from=modifyPassword') !== -1) {
                // 修改密码后跳转到登录页
                parent.location.href = '/logout/';
            } else {
                // 隐藏弹窗
                parent.window.hideEpassportModal();
            }
        }
    }, []);
    return <div />;
}

export default EpassportContinue;
